/* Copyright (c) 2025 Xperi. All Rights Reserved. */

/**
 * Error code constants for suffix codes.
 * These constants represent the suffix codes appended to base error IDs.
 *
 * Code categories:
 * - N6xx: Network-related errors
 * - S6xx: Service context and authentication errors
 * - G4xx-G6xx: Generic HTTP status code errors
 */
export class ErrorCodes {
    // Network errors (N6xx)
    public static readonly NETWORK_UNKNOWN_SERVER: string = 'N601';

    public static readonly NETWORK_CONNECTION_REFUSED: string = 'N602';

    public static readonly NETWORK_CONNECTION_FAILED: string = 'N603';

    public static readonly NETWORK_HTTP_BAD_REQUEST: string = 'N604';

    public static readonly NETWORK_BAD_RESPONSE: string = 'N605';

    public static readonly NETWORK_SHORT_RESPONSE: string = 'N606';

    public static readonly NETWORK_IO_ERROR: string = 'N607';

    public static readonly NETWORK_FILE_NOT_FOUND: string = 'N608';

    public static readonly NETWORK_GENERAL_ERROR: string = 'N609';

    // Service context errors (S6xx)
    public static readonly SERVICE_BRIDGEKEEPER_DENIED: string = 'S601';

    public static readonly SERVICE_CONNECTION_FAILED: string = 'S602';

    public static readonly SERVICE_CONNECTION_LOST: string = 'S603';

    public static readonly SERVICE_INVALID_RESPONSE: string = 'S604';

    public static readonly SERVICE_INTERNAL_ERROR: string = 'S605';

    public static readonly SERVICE_CREDENTIAL_FAILED: string = 'S606';

    public static readonly SERVICE_CREDENTIAL_EXPIRED: string = 'S607';

    public static readonly SERVICE_CREDENTIAL_NOT_AUTHORIZED: string = 'S608';

    public static readonly SERVICE_DEVICE_LIST_RETRIEVAL_FAILED: string = 'S609';

    public static readonly SERVICE_NO_AUTHENTICATE_RESPONSE: string = 'S610';

    public static readonly SERVICE_MIDDLEMIND_ERROR: string = 'S611';

    public static readonly SERVICE_TIMEOUT: string = 'S612';

    public static readonly SERVICE_SERVER_NOT_RESOLVED: string = 'S613';

    public static readonly SERVICE_INVALID_CONTEXT_STATE: string = 'S614';

    public static readonly SERVICE_CONTEXT_DESTROYED: string = 'S615';

    public static readonly SERVICE_SCHEMA_EXCEPTION: string = 'S616';

    public static readonly SERVICE_INVALID_ACCESS_TOKEN: string = 'S617';

    public static readonly SERVICE_REQUEST_CONTEXT_ERROR: string = 'S618';

    // HTTP/Generic errors (G4xx-G6xx)
    public static readonly HTTP_BAD_REQUEST: string = 'G400';

    public static readonly HTTP_UNAUTHORIZED: string = 'G401';

    public static readonly HTTP_FORBIDDEN: string = 'G403';

    public static readonly HTTP_NOT_FOUND: string = 'G404';

    public static readonly HTTP_METHOD_NOT_ALLOWED: string = 'G405';

    public static readonly HTTP_CONFLICT: string = 'G409';

    public static readonly HTTP_UNSUPPORTED_MEDIA_TYPE: string = 'G415';

    public static readonly HTTP_TOO_MANY_REQUESTS: string = 'G429';

    public static readonly HTTP_INTERNAL_SERVER_ERROR: string = 'G500';

    public static readonly HTTP_BAD_GATEWAY: string = 'G502';

    public static readonly HTTP_SERVICE_UNAVAILABLE: string = 'G503';

    public static readonly HTTP_GATEWAY_TIMEOUT: string = 'G504';

    public static readonly HTTP_GENERIC_ERROR: string = 'G600';
}
